import { Room } from './RoomList'

export class SearchCondition {
  sheet_code: string = ""
  curriculum_id: string = ""
  grade: string = ""
  nendo: string = ""
  event_code: string = ""
  page: number = 1
  row_count: number =  20
}

export class BaseSheet {
  id: number
  sheet_code: string
  nendo: number
  month: number
  name: string
  curriculum_id: number
  grade: number
  level: string
  field_names_completed: boolean
  corretct_image_completed: boolean
  field_positions_completed: boolean
  explanation_image_completed: boolean
  question_image_completed: boolean
  part1_image_completed: boolean
  field_names_completed_text: string
  corretct_image_completed_text: string
  field_positions_completed_text: string
  explanation_image_completed_text: string
  question_image_completed_text: string
  part1_image_completed_text: string
  is_checked: boolean = false
  saiten_completed: boolean = false
  misaiten_rooms: Room[]
  sheet_process_ids: number[]
  aggregated_at: string
  saiten_completed_count: number
  event_code: number


  constructor(base_sheet: any){
    this.id = base_sheet.id;
    this.sheet_code = base_sheet.sheet_code;
    this.nendo = base_sheet.nendo;
    this.month = base_sheet.month;
    this.name = base_sheet.name;
    this.curriculum_id = base_sheet.curriculum_id;
    this.grade = base_sheet.grade;
    this.level = base_sheet.level;
    this.field_names_completed = base_sheet.field_names_completed;
    this.corretct_image_completed = base_sheet.corretct_image_completed;
    this.field_positions_completed = base_sheet.field_positions_completed;
    this.explanation_image_completed = base_sheet.explanation_image_completed;
    this.question_image_completed = base_sheet.question_image_completed;
    this.part1_image_completed = base_sheet.part1_image_completed;
    this.field_names_completed_text = base_sheet.field_names_completed ? "○" : "-";
    this.corretct_image_completed_text = base_sheet.corretct_image_completed ? "○" : "-";
    this.field_positions_completed_text = base_sheet.field_positions_completed ? "○" : "-";
    this.explanation_image_completed_text = base_sheet.explanation_image_completed ? "○" : "-";
    this.question_image_completed_text = base_sheet.question_image_completed ? "○" : "-";
    this.part1_image_completed_text = base_sheet.part1_image_completed ? "○" : "-";
    this.saiten_completed = base_sheet.saiten_completed;
    this.misaiten_rooms = base_sheet.misaiten_rooms;
    this.sheet_process_ids = base_sheet.sheet_process_ids;
    this.aggregated_at = base_sheet.aggregated_at;
    this.saiten_completed_count = base_sheet.saiten_completed_count;
    this.event_code = base_sheet.event_code;
  }
}